module.exports = __webpack_public_path__ + "img/img8.03630693.png";